import messages from './cmsArticle.json' with { type: 'json' };

export const cmsArticleFi: Readonly<typeof messages> = messages;
